// extracted by mini-css-extract-plugin
module.exports = {"app_btn":"button_app_btn__zhzvT","spin":"button_spin__akLPG","thin":"button_thin__WeBGj","btn_icon":"button_btn_icon__1Yx0b"};